import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";

export const deleteModal = ({
  title,
  children,
  onConfirm,
  confirmLabelText = "삭제하기",
  zIndex = 1000,
  description,
  ...rest
}) => {
  modals.openConfirmModal({
    title: title || "삭제하시겠습니까?",
    centered: true,
    zIndex,
    children: <Text size="sm">{children || description || "삭제 후에는 데이터를 복구할 수 없습니다"}</Text>,
    labels: { confirm: confirmLabelText, cancel: "취소" },
    confirmProps: { color: "red" },
    onConfirm,
    ...rest,
  });
};
